import React, { ComponentProps, FC } from 'react';

import { Flex } from '@adsk/alloy-react-box';

const FlexCentered: FC<
  Omit<ComponentProps<typeof Flex>, 'justifyContent' | 'alignItems'>
> = (props) => <Flex justifyContent="center" alignItems="center" {...props} />;

export default FlexCentered;
